// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KkVH","inner":"styles_inner__2OKdN","right":"styles_right__1cU7U","close":"styles_close__8vNaW","footer":"styles_footer__3-BOc"};